import cn from "classnames";

import React, { useMemo } from "react";

import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import FlightLandOutlinedIcon from "@mui/icons-material/FlightLandOutlined";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { Fab, Grid, IconButton } from "@mui/material";

import { AirportMapItem } from "@/constants/airport";
import useEvent from "@/hooks/useEvent";
import usePlatform from "@/hooks/usePlatform";

import SelectAirport from "./SelectAirport";

interface AlertModalProps {
  fromLocation: AirportMapItem[];
  toLocation: AirportMapItem[];
  maxCount?: number;
  onChange: (data: { fromLocation: AirportMapItem[]; toLocation: AirportMapItem[] }) => void;
}

const Airport = ({ fromLocation, toLocation, maxCount, onChange }: AlertModalProps) => {
  const { isMobile } = usePlatform();

  const disableSwap = useMemo(() => {
    return !fromLocation.length || !toLocation.length;
  }, [fromLocation, toLocation]);

  const onLocationSwapChange = useEvent(() => {
    onChange({
      fromLocation: toLocation,
      toLocation: fromLocation,
    });
  });

  return (
    <Grid container alignItems="center" rowGap={2} className="relative">
      <Grid item xs={isMobile ? 12 : 5.6}>
        <SelectAirport
          placeholder="Where from?"
          Icon={<FlightTakeoffOutlinedIcon />}
          selectData={fromLocation}
          maxCount={maxCount}
          onChange={(data) => {
            onChange({ toLocation, fromLocation: data });
          }}
        />
      </Grid>

      {!isMobile ? (
        <Grid item xs alignItems="center">
          <div className="flex items-center justify-center">
            <IconButton
              aria-label="swap"
              size="small"
              onClick={onLocationSwapChange}
              disabled={disableSwap}
            >
              <SwapHorizIcon />
            </IconButton>
          </div>
        </Grid>
      ) : (
        <div className={cn("absolute right-[30px] z-10", { hidden: disableSwap })}>
          <Fab color="primary" aria-label="swap" size="small" onClick={onLocationSwapChange}>
            <SwapHorizIcon className="rotate-90" />
          </Fab>
        </div>
      )}

      <Grid item xs={isMobile ? 12 : 5.6}>
        <SelectAirport
          placeholder="Where to?"
          Icon={<FlightLandOutlinedIcon />}
          selectData={toLocation}
          maxCount={maxCount}
          onChange={(data) => {
            onChange({ fromLocation, toLocation: data });
          }}
        />
      </Grid>
    </Grid>
  );
};

export default React.memo(Airport);
